import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../core/services/auth.service';
import {NewsService} from '../../core/services/news.service';
import {Router} from '@angular/router';
import {LearningResourceService} from '../../core/services/learning-resource.service';
import {EventService} from '../../core/services/event.service';
import {DatePipe} from '@angular/common';
import {FeedService} from '../../core/services/feed.service';
import {NzMessageService} from "ng-zorro-antd/message";
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

interface UserProfile {
  profilePicture?: { url: string } | null;
  regCode: string;
  position: string;
  description: string;
  description1: [];
  name: string;
  grade: string;
  firstLogin: string;
  dashboardSettings: {
    recentArticles: boolean;
    recentBooks: boolean;
    recentPosts: boolean;
    recentNews: boolean;
    myProfile: boolean;
    calendar: boolean;
    invitedEvents: boolean;
    upcomingEvents: boolean;
  } | null;
  _id: string;
}

interface Member {
  workplace: string;
  position: string;
  name: string;
  id: string;
}

@Component({
  selector: 'app-users',
  templateUrl: './dashbord.component.html',
  styleUrls: ['./dashbord.component.scss'],
})
export class DashbordComponent implements OnInit {
  breadcrumbs = [
    {
      title: 'Dashboard',
    },
  ];

  user: UserProfile = {
    profilePicture: null,
    regCode: '',
    position: '',
    grade: '',
    description: '',
    description1: [],
    name: '',
    dashboardSettings: {
      recentArticles: true,
      recentBooks: true,
      recentPosts: true,
      recentNews: true,
      myProfile: true,
      calendar: true,
      invitedEvents: true,
      upcomingEvents: true,
    },
    firstLogin: '',
    _id: '',
  };

  calEventData: any[] = [];
  calEventDataTemp: any[] = [];
  news: any[] = [];
  books: any[] = [];
  events: any[] = [];
  feed: any[] = [];
  articles: any[] = [];
  isExpanded: boolean[] = [];
  isExpandedTextLen: number[] = [];
  isExpandedPost: boolean[] = [];
  pageNoPost = 1;
  pageNoArticle = 1;
  pageSize = 5;
  wordCap = 250;
  isVisible = false;
  isVisibleForm = false;
  isAttendanceForm = false;
  attendanceForm! : FormGroup;
  selectedEvent: any = null;
  selectedEventID = "";
  invitedEvents: any[] = [];
  calDate = new Date();
  structuredEventDays: any[] = [];
  dashboardSettings: {
    recentArticles: boolean;
    recentBooks: boolean;
    recentPosts: boolean;
    recentNews: boolean;
    myProfile: boolean;
    calendar: boolean;
    invitedEvents: boolean;
    upcomingEvents: boolean;
  } | null = {
    recentArticles: true,
    recentBooks: true,
    recentPosts: true,
    recentNews: true,
    myProfile: true,
    calendar: true,
    invitedEvents: true,
    upcomingEvents: true,
  };

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private newService: NewsService,
    private resourceService: LearningResourceService,
    private router: Router,
    private eventService: EventService,
    private datePipe: DatePipe,
    private feedService: FeedService,
    private message: NzMessageService
  ) {}

  ngOnInit(): void {
    this.user = this.authService.getLoggedInUser(); 
    if (this.user.dashboardSettings) {
      this.dashboardSettings = this.user.dashboardSettings;
    } else {
      this.user.dashboardSettings = this.dashboardSettings;
      this.authService.setLoggedInUser(JSON.stringify(this.user));
      this.authService.updateUser({
        _id: this.user._id,
        dashboardSettings: this.dashboardSettings,
      });
      window.location.reload()
    }

    if (this.user.firstLogin) {
      if (this.user.firstLogin === 'false') {
        this.showModal();
      }
    }
    this.loadNews();
    this.loadBooks();
    this.loadEvents();
    this.loadPost();
    this.loadArticles();
    this.loadInvitedEvents();
    this.loadEventsCal();
    this.initAttendanceForm();
  }

  onDashboardChange(id: number): void {
    if (this.dashboardSettings) {
      if (id === 1) {
        this.dashboardSettings.recentArticles =
          !this.dashboardSettings.recentArticles;
      } else if (id === 2) {
        this.dashboardSettings.recentBooks =
          !this.dashboardSettings.recentBooks;
      } else if (id === 3) {
        this.dashboardSettings.recentNews = !this.dashboardSettings.recentNews;
      } else if (id === 4) {
        this.dashboardSettings.recentPosts =
          !this.dashboardSettings.recentPosts;
      } else if (id === 5) {
        this.dashboardSettings.myProfile = !this.dashboardSettings.myProfile;
      } else if (id === 6) {
        this.dashboardSettings.calendar = !this.dashboardSettings.calendar;
      } else if (id === 7) {
        this.dashboardSettings.invitedEvents =
          !this.dashboardSettings.invitedEvents;
      } else if (id === 8) {
        this.dashboardSettings.upcomingEvents =
          !this.dashboardSettings.upcomingEvents;
      }

      this.user.dashboardSettings = this.dashboardSettings;
      this.authService.setLoggedInUser(JSON.stringify(this.user));
      this.authService.updateUser({
        _id: this.user._id,
        dashboardSettings: this.dashboardSettings,
      });
    }
  }

  loadNews(): void {
    this.newService.getNews(1, 6).then((response) => {
      this.news = response.docs;

    });
  }

  loadBooks(): void {
    this.resourceService.getBooks(1, 6).then((response) => {
      this.books = response.docs;
    });
  }

  loadEvents(): void {
    this.eventService.getEventsByStartDate().then((response: any) => {
      if (response && response.docs) {
        // Sort events by start date (ascending)
        const sortedEvents = response.docs.sort((a: any, b: any) => {
          const dateA = new Date(a.startTime).getTime();
          const dateB = new Date(b.startTime).getTime();
          return dateA - dateB;
        });

        // Show all events (up to 4), sorted by start date
        const sliceCount = Math.min(sortedEvents.length, 4);
        this.events = sortedEvents.slice(0, sliceCount);
      } else {
        this.events = [];
      }
    }).catch((error) => {
      console.error('Error loading events:', error);
      this.events = [];
    });
  }



  navToSingleArticle(data: any): void {
    this.router.navigate([`/admin/single-resource/${data.id}`]);
  }

  loadEventsCal(): void {
    this.eventService.getEvents(0, 0).then((response) => {
      this.calEventData = response.docs;
      this.calEventData = this.filterEventsByStartDate(
        this.calEventData,
        this.calDate,
      );
      this.calEventDataTemp = response.docs;
      this.structuredEventDays = this.calEventDataTemp.map((event) => {
        const startDate = new Date(event.startTime);
        return {
          id: event.id,
          day: startDate.getDate(),
          month: startDate.getMonth(),
          year: startDate.getFullYear(),
        };
      });
    });
  }

  loadPost(): void {
    this.feedService
      .getFeedByOrder(this.pageNoPost, this.pageSize)
      .then((res) => {
        this.feed = this.feed.concat(res.docs);
        this.isExpandedPost = this.feed.map(() => false);
      });
  }

  loadArticles(): void {
    this.resourceService
      .getArticles(this.pageNoArticle, this.pageSize)
      .then((res) => {
        this.articles = this.articles.concat(res.docs);
      
        this.isExpandedTextLen = this.articles.map((article) => {
          const descriptionArray = article.description1; // Assuming description1 is the property containing the array
          return descriptionArray.reduce((total: any, item: any) => {
            if (item.children[0]) {
              return total + item.children[0].text.length;
            } else {
              return total;
            }
          }, 0);
        });
        this.isExpanded = this.articles.map(() => false);
      });
  }

  loadInvitedEvents(): void {
    // Since all events are now open, show events where user has responded
    this.eventService.getEventsByStartDate().then((res: any) => {
      if (res && res.docs) {
        const currentDate = new Date();
        // Filter events where user has responded (willAttend or willNotAttend) and are in the future
        this.invitedEvents = res.docs.filter((doc: any) => {
          const startDate = new Date(doc.startTime);
          const hasResponded = 
            (doc.willAttend && doc.willAttend.some((m: any) => {
              const memberId = typeof m === 'string' ? m : m?.id;
              return memberId === this.user._id;
            })) ||
            (doc.willNotAttend && doc.willNotAttend.some((m: any) => {
              const memberId = typeof m === 'string' ? m : m?.id;
              return memberId === this.user._id;
            }));
          return hasResponded && startDate > currentDate;
        });
      } else {
        this.invitedEvents = [];
      }
    }).catch((error) => {
      console.error('Error loading invited events:', error);
      this.invitedEvents = [];
    });
  }


  toggleExpansion(index: number): void {
    this.isExpanded[index] = !this.isExpanded[index];
  }

  toggleExpansionPost(index: number): void {
    this.isExpandedPost[index] = !this.isExpandedPost[index];
  }

  navigateToMemberFeed(id: any) {
    this.router.navigate(['/admin/member-view/', { id }]);
  }

  navigateToNews(id: any): void {
    this.router.navigate(['/admin/single-news/', { id }]);
  }

  viewEvent(id: any): void {
    this.router.navigate(['/admin/single-event/', { id }]);
  }

  formatDate(startDate: string, endDate: string): any {
    const start = new Date(startDate);
    const end = new Date(endDate);

    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      return 'Invalid Date Range';
    }

    const startYear = start.getFullYear();
    const startMonth = new Intl.DateTimeFormat('en-US', {
      month: 'long',
    }).format(start);
    const startDay = start.getDate();

    const startTimeStr = start.toLocaleTimeString(undefined, {
      hour: 'numeric',
      minute: 'numeric',
    });
    const endTimeStr = end.toLocaleTimeString(undefined, {
      hour: 'numeric',
      minute: 'numeric',
    });

    const startDateStr = `${startMonth} ${startDay} ${startYear}`;

    return `${startDateStr} | ${startTimeStr} - ${endTimeStr}`;
  }

  formatDateAlt(date: string): any {
    const originalDate = new Date(date);
    return this.datePipe.transform(originalDate, 'h.mm a MMM d, y');
  }

  onValueChange(date: any): void {
    this.calEventData = this.calEventDataTemp;
    if (date === null) {
      this.loadEvents();
    } else {
      this.calEventData = this.filterEventsByStartDate(this.calEventData, date);

    }
  }

  filterEventsByStartDate(originalEvents: any[], dateToCompare: Date): any[] {
    return originalEvents.filter((event) => {
      const startDate = new Date(event.startTime);
      return (
        startDate.getFullYear() === dateToCompare.getFullYear() &&
        startDate.getMonth() === dateToCompare.getMonth() &&
        startDate.getDate() === dateToCompare.getDate()
      );
    });
  }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/img/placeholder_image.jpg';
  }

  onImageProfile(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/img/avatar_image.jpg';
  }

  showModal(): void {
    this.isVisible = true;
  }

  handleOk(): void {
    this.user.firstLogin = 'True'
    this.authService.setLoggedInUser(JSON.stringify(this.user));
    this.authService.updateUser({ _id: this.user._id, firstLogin: 'True' });
    this.router.navigate(['/auth/forgot-password'], {
      queryParams: { flag: 'reset' },
    });
  }

  handleCancel(): void {
    this.authService.updateUser({ _id: this.user._id, firstLogin: 'True' });
    this.user.firstLogin = 'True'
    this.authService.setLoggedInUser(JSON.stringify(this.user));
    this.isVisible = false;
    this.isAttendanceForm = false;
    // this.event = null;
  }

  // Attendence Form

  attendance: {
    name: string;
    designation: string;
    station: string;
    adultCount: string;
    childrenCount: string;
    childrenAge: string;
    roomType: string;
    datesOfStay: string;
  } = {
    name: '',
    designation: '',
    station: '',
    adultCount: '',
    childrenCount: '',
    childrenAge: '',
    roomType: '',
    datesOfStay: '',
  };

  initAttendanceForm(): void {
    this.attendanceForm = this.formBuilder.group({
      name: [this.attendance?.name || ''],
      designation: [this.attendance?.designation || '', Validators.required],
      station: [this.attendance?.station || '', Validators.required],
      adultCount: [this.attendance?.adultCount || '', [Validators.required, Validators.pattern('^[0-9]*$')]],
      childrenCount: [this.attendance?.childrenCount || '', [Validators.required, Validators.pattern('^[0-9]*$')]],
      childrenAge: [this.attendance?.childrenAge || ''],
      roomType: [this.attendance?.roomType || '', Validators.required],
      datesOfStay: [this.attendance?.datesOfStay || '', Validators.required],
    });
  }

  getFormControl(controlName: string) {
    return this.attendanceForm.get(controlName);
  }

  showModalAttendence(event : any): void {
    this.isVisible = true;
    this.isAttendanceForm = true;
    this.selectedEventID = event.id;
    this.selectedEvent = event;

  }

  handleAttendanceFormSubmit(): void {
    if (this.attendanceForm.invalid) {
        for (const i in this.attendanceForm.controls) {
            if (this.attendanceForm.controls.hasOwnProperty(i)) {
                this.attendanceForm.controls[i].markAsDirty();
                this.attendanceForm.controls[i].updateValueAndValidity();
            }
        }
        return;
    }

    const formData = this.attendanceForm.value;
    const newAttendee = {
        name: this.user.name,
        designation: formData.designation,
        station: formData.station,
        adultCount: formData.adultCount,
        childrenCount: formData.childrenCount,
        childrenAge: formData.childrenAge,
        roomType: formData.roomType,
        datesOfStay: formData.datesOfStay,
    };

    this.eventService.getEventsById(this.selectedEventID)
        .then(event => {
            const currentAttendees = event.attendees || [];
            const updatedAttendees = [...currentAttendees, newAttendee];

            this.eventService.updateEvent(this.selectedEventID, { attendees: updatedAttendees })
                .then(() => {
                    this.addParticipant('Add', this.selectedEvent)
                    this.message.create('success', 'Registration Status Updated Successfully');
                })
                .catch(() => {
                    this.message.create('error', 'Failed to Update Event Registration');
                });

            this.isVisible = false;
            this.isAttendanceForm = false;
        })
        .catch(() => {
            this.message.create('error', 'Failed to Fetch Current Attendees');
        });
}




  addParticipant(reply: any, event: any): void {
    let payload: {
      accepted?: string[];
      rejected?: string[];
      member?: string[];
    } = {}; // Initialize as an object
    let memberAcceptedIds: string[] = [];
    let memberInvitedIds: string[] = [];
    let rejectedIds: string[] = [];

    if (this.user._id) {
      if (reply === 'Add') {
        if (event.accepted) {
          memberAcceptedIds = event.accepted.map((member: Member) => member.id);
        }
        memberAcceptedIds.push(this.user._id);
        payload = { accepted: memberAcceptedIds };

        if (event.member.some((item: Member) => item.id === this.user._id)) {
          memberInvitedIds = event.member
            .filter((item: Member) => item.id !== this.user._id)
            .map((item: Member) => item.id);
          payload = { accepted: memberAcceptedIds, member: memberInvitedIds };
        }

        this.eventService.updateEvent(event.id, payload).then(() => {
          this.message.create('success', `Participation confirmed successfully!`);
          this.ngOnInit();
        });
      } else if (reply === 'Reject') {
        if (event.rejected) {
          rejectedIds = event.rejected.map((member: Member) => member.id);
        }
        rejectedIds.push(this.user._id);

        memberInvitedIds = event.member
          .filter((item: Member) => item.id !== this.user._id)
          .map((item: Member) => item.id);
        payload = { rejected: rejectedIds, member: memberInvitedIds };

        this.eventService.updateEvent(event.id, payload).then(() => {
          this.message.create('success', `Participation rejected successfully!`);
          this.ngOnInit();
        });
      }
    }
  }

  serializeToHTMLFull(children: any[]): string {
    return children
      .map((node, i) => {
        if (node && typeof node === 'object' && 'text' in node) {
          let text = `<span>${this.escapeHTML(node.text)}</span>`;

          if (node.bold) {
            text = `<strong>${text}</strong>`;
          }

          if (node.code) {
            text = `<code>${text}</code>`;
          }

          if (node.italic) {
            text = `<em>${text}</em>`;
          }

          if (node.underline) {
            text = `<u>${text}</u>`;
          }
          return text;
        }

        if (!node) {
          return null;
        }

        switch (node.type) {
          case 'h1':
            return `<h1>${this.serializeToHTMLFull(node.children)}</h1>`;
          case 'h2':
            return `<h2>${this.serializeToHTMLFull(node.children)}</h2>`;
          case 'h3':
            return `<h3>${this.serializeToHTMLFull(node.children)}</h3>`;
          case 'h4':
            return `<h4>${this.serializeToHTMLFull(node.children)}</h4>`;
          case 'h5':
            return `<h5>${this.serializeToHTMLFull(node.children)}</h5>`;
          case 'h6':
            return `<h6>${this.serializeToHTMLFull(node.children)}</h6>`;
          case 'blockquote':
            return `<blockquote>${this.serializeToHTMLFull(node.children)}</blockquote>`;
          case 'ul':
            return `<ul>${this.serializeToHTMLFull(node.children)}</ul>`;
          case 'ol':
            return `<ol>${this.serializeToHTMLFull(node.children)}</ol>`;
          case 'li':
            return `<li>${this.serializeToHTMLFull(node.children)}</li>`;
          case 'link':
            return `<a class="richLink" href="${this.escapeHTML(node.url)}">${this.serializeToHTMLFull(
              node.children
            )}</a>`;

          default:
            return `<p class="font-[400]">${this.serializeToHTMLFull(node.children)}</p>`;
        }
      })
      .join('');
  }


  serializeToHTML(children: any[]): string {
    const result = children
      .map((node, i) => {
        if (node && typeof node === 'object' && 'text' in node) {
          let truncatedText = node.text.length > 200 ? `${node.text.slice(0, 200)}...` : node.text;
          let text = `<span>${this.escapeHTML(truncatedText)}</span>`;

          if (node.bold) {
            text = `${text}`;
          }

          if (node.code) {
            text = `${text}`;
          }

          if (node.italic) {
            text = `${text}`;
          }

          if (node.underline) {
            text = `${text}`;
          }

          return text;
        }

        if (!node) {
          return null;
        }

        switch (node.type) {
          case 'h1':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h2':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h3':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h4':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h5':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h6':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'blockquote':
            return `<blockquote>${this.serializeToHTML(node.children)}</blockquote>`;
          case 'ul':
            return `<ul>${this.serializeToHTML(node.children)}</ul>`;
          case 'ol':
            return `<ol>${this.serializeToHTML(node.children)}</ol>`;
          case 'li':
            return `<li>${this.serializeToHTML(node.children)}</li>`;
          case 'link':
            return `<p >${this.serializeToHTML(
              node.children
            )}</p>`;

          default:
            return `<p class="font-[400]">${this.serializeToHTML(node.children)}</p>`;
        }
      })
      .join('');

    // Truncate the result to 250 characters
    return result.length > 200 ? `${result.slice(0, 200)}...` : result;
  }

  serializeToHTMLStyle(children: any[]): string {
    const result = children
      .map((node, i) => {
        if (node && typeof node === 'object' && 'text' in node) {
          let truncatedText = node.text.length > 200 ? `${node.text.slice(0, 200)}...` : node.text;
          let text = `<span>${this.escapeHTML(truncatedText)}</span>`;

          if (node.bold) {
            text = `<strong>${text}</strong>`;
          }

          if (node.code) {
            text = `<code>${text}</code>`;
          }

          if (node.italic) {
            text = `<em>${text}</em>`;
          }

          if (node.underline) {
            text = `<u>${text}</u>`;
          }

          return text;
        }

        if (!node) {
          return null;
        }

        switch (node.type) {
          case 'h1':
            return `<h1>${this.serializeToHTMLStyle(node.children)}</h1>`;
          case 'h2':
            return `<h2>${this.serializeToHTMLStyle(node.children)}</h2>`;
          case 'h3':
            return `<h3>${this.serializeToHTMLStyle(node.children)}</h3>`;
          case 'h4':
            return `<h4>${this.serializeToHTMLStyle(node.children)}</h4>`;
          case 'h5':
            return `<h5>${this.serializeToHTMLStyle(node.children)}</h5>`;
          case 'h6':
            return `<h6>${this.serializeToHTMLStyle(node.children)}</h6>`;
          case 'blockquote':
            return `<blockquote>${this.serializeToHTMLStyle(node.children)}</blockquote>`;
          case 'ul':
            return `<ul>${this.serializeToHTMLStyle(node.children)}</ul>`;
          case 'ol':
            return `<ol>${this.serializeToHTMLStyle(node.children)}</ol>`;
          case 'li':
            return `<li>${this.serializeToHTMLStyle(node.children)}</li>`;
          case 'link':
            return `<a class="richLink" href="${this.escapeHTML(node.url)}">${this.serializeToHTMLStyle(
              node.children
            )}</a>`;

          default:
            return `<p class="font-[400]">${this.serializeToHTMLStyle(node.children)}</p>`;
        }
      })
      .join('');

    // Truncate the result to 250 characters
    return result.length > 200 ? `${result.slice(0, 200)}...` : result;
  }

  private escapeHTML(text: string): string {
    return text;
  }

}
